<template>
    <v-tab-item
        eager
    >
        <v-row>
            <v-col cols="12" class="col-sm-2 pa-sm-6">
                <span class="font-weight-medium">{{$t('processingPhases')}}</span>
            </v-col>
            <v-col cols="12" class="col-sm-10">
                <v-tabs
                    v-model="activeTab"
                    active-class=" body-2 font-weight-bold text-capitalize text--main-yellow"
                    slider-color="orange lighten-2"
                    ref="tabs"
                >
                    <v-tab
                        v-for="(tab, idx) in Number(treatments.length)"
                        :key="idx"
                    >T{{ tab-1 }}</v-tab>

                </v-tabs>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-tabs-items
                    v-model="activeTab"
                >
                    <treatment-tab
                        v-for="(tab, idx) in Number(treatments.length)"
                        :key="idx"
                        :calculationIdx="calculationIdx"
                        :treatmentIdx="idx"
                        :attributes="attributes"
                        :categories="categories"
                    ></treatment-tab>
                </v-tabs-items>
            </v-col>
        </v-row>
        <v-row
            justify="end"
        >
            <v-col cols="12" class="col-md-10">
                <div class="text-right text-subtitle-1 font-weight-bold">{{ $t('commonBudgetOnHectare') }}: </div>
            </v-col>
            <v-col cols="12" class="col-md-2">
                <div class="text-right text-md-left">{{ formatBudget }} {{ currency.toUpperCase() }}</div>
            </v-col>
        </v-row>
    </v-tab-item>
</template>

<script>
import TreatmentTab from "./TreatmentTab";
import numberFormat from "../../../../utils/numberFormat";
export default {
    name: "CultureTab",
    components: {
        TreatmentTab
    },
    props: ['calculationIdx', 'attributes', 'categories'],
    data() {
        return {
            activeTab: 0
        }
    },
    computed: {
        treatments() {
            const calculation = this.$store.getters.calculatorFullData[this.calculationIdx];
            return calculation.treatments ? calculation.treatments : [];
        },
        currency() {
            return this.$store.getters.appCurrency;
        },
        summaryBudget() {
            let sum = 0;
            if(this.treatments.length > 0) {
                sum = this.treatments.reduce((accum, treatment) => {
                    const treatmentSum = treatment.reduce((accum, category) => {
                        const budget = category.budget ?  parseFloat(category.budget) : 0;
                        return accum + budget;
                    },0);
                    return accum + treatmentSum;
                }, sum)
            }
            return sum;
        },
        formatBudget() {
            return numberFormat(this.summaryBudget, 2, '.', ' ');
        },
    },

}
</script>

<style scoped>

</style>
